import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const todayRecommendsConfigApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/todayrecommends-config/`, {params: params})
  },
  detail (todayRecommendsConfigId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/todayrecommends-config/${todayRecommendsConfigId}/`, {params: params})
  }
}

export default todayRecommendsConfigApi
